import {getUrl} from "./main_ptx";


/**
 * Create address resolving box
 * @alias Ptx.html.resolvAddressBox
 * @param htmlElement - html element to render for box, default to div if null
 * @param type - trackPoint,incident etc, if null then defaults to 'trackPoint'
 * @param address - address to show before resolving, if null or empty or undefined
 * @param entityId
 * @param lat
 * @param lon
 * @param clientId
 * @param unitId
 * @param cssClass - additional css class for box element
 * @returns {String} with box
 */
export function resolvAddressBox(htmlElement, type, address, entityId, lat, lon, clientId, unitId, cssClass) {
	var ele = (htmlElement != null ? htmlElement : 'div');
	var _type = (type != null ? type : 'trackPoint');
	var shouldResolve = (typeof address === 'undefined' || address == null || address == '') && lat && lon;
	var css = shouldResolve ? ('resolve ' + cssClass) : cssClass;
	if (typeof entityId === 'undefined') {
		entityId = '';
	} else {
		entityId = (entityId == 'undefined' ? '' : entityId);//sometimes there is undefined for EoD in logbook map
	}

	var html = '<' + ele + ' id="address_' + _type + '_' + entityId + '" class="' + css + '" '
			+ ' data-entity-id="' + entityId + '" data-type="' + type + '" data-lat="' + lat + '" data-lon="' + lon + '"'
			+ ' data-client-id="' + clientId + '" data-unit-id="' + unitId + '">';

	if (shouldResolve) {
		html += '<span id="spinner_' + type + '_' + entityId + '">'+Ptx.html.icon({icon: "fa-spinner fa-pulse"})+'</span>'
	}

	html += (address == null ? "" : address);
	html += '</' + ele + '>';

	return html;
}

/**
 * Create list of <li> with sms commands for unit
 * @alias Ptx.html.smsCommands
 * @param unitId
 * @param smsTemplatesAvailable
 * @param isGDSP
 * @return html of <li> elements of commands
 */
export function smsCommands(unitId, smsTemplatesAvailable, isGDSP) {
	if (!Array.isArray(smsTemplatesAvailable) || !smsTemplatesAvailable.length) return '';

	const isUnitGDSP = isGDSP ? 'GDSP' : 'SMS';
	const smsCommands = [
		{ key: 'GPSD', icon: 'fa-map-marker-alt', cssClass: 'text-primary', textKey: 'requestPosition', text: 'GPSD' },
		{ key: 'SENDLOG', icon: 'fa-download', cssClass: 'text-info', textKey: 'requestReport', text: 'Report' },
		{ key: 'STOP', icon: 'fa-times', cssClass: 'text-danger', textKey: 'requestStop', text: 'Stop' },
		{ key: 'START', icon: 'fa-check', cssClass: 'text-success', textKey: 'requestStart', text: 'Start' }
	];

	const filteredCommands = smsCommands.filter(cmd => smsTemplatesAvailable.includes(cmd.key));
	if (!filteredCommands.length) return '';

	return `
        <li class="dropdown-header">${Ptx.getMsg(`map.${isUnitGDSP}.commandDrive`)}</li>
        ${filteredCommands.map(cmd => `
            <li>
                <a href="#" class="ptx-send-sms" data-unit-id="${unitId}" data-sms-template="${cmd.key}" data-gdsp="${isUnitGDSP}">
                    ${Ptx.html.icon({ icon: cmd.icon, cssClass: `fa-fw ${cmd.cssClass}` })}
                    <span>${Ptx.getMsg(`map.${isUnitGDSP}.${cmd.textKey}`)}</span>
                </a>
            </li>
        `).join('')}
    `;
}

/**
 * Creates button, helps with icon, content etc.
 * @alias Ptx.html.btn
 * @param o config object - href -required - target, icon - can be empty - whole class content of i include Font Awesome icon name, faStyle - (solid,
 *          regular, brands) can be empty (default "fa-solid") Font Awesome icon type, contentHtml - can be empty - content of a tag (without icon),
 *          moreLinkAttributes - can be
 *          empty -
 *          more attributes or content for a tag
 * @returns {string}
 */
export function btn(o) {
	var iconTitle = o.iconTitle ? ('title="' + o.iconTitle + '"') : '';

    let iconType = getFaClassFromAlias(o.faStyle);

	var iconHtml = o.icon ? '<i class="' + iconType + ' ' + o.icon + '" ' + iconTitle + '></i>' : '';

	var addToLinkHtml = o.moreLinkAttributes ? ' ' + o.moreLinkAttributes : '';
	var contentHtml = o.content ? o.content : '';
	return '<a type="button" class="' + o.className + '" href="' + o.href + '"' + addToLinkHtml + '>' + iconHtml + ' ' + contentHtml + '</a>';
}

/**
 * Gets localized message, otherwise creates span tag for resolving single message from server.
 * @alias Ptx.html.msg
 * @param o config object - key - required - key for message, placeholder - can be null - html text in span
 * @returns {string}
 */
export function msg(o) {
	const key = o.key;
	const val = Ptx.getMsg(key);
	if (typeof val !== 'undefined') {
		return val;
	}
	const placeholderHtml = o ? o.placeholder : '';
	return '<span class="resolve" data-key="' + o.key + '">' + placeholderHtml + '</span>';
}


/**
 * Gets Font Awesome type class (fa-solid, fa-regular, fa-brands) from alias
 * (solid = fa-solid, regular = fa-regular, brand = fa-brands)
 * @param alias
 * @returns {string}
 */
function getFaClassFromAlias(alias) {
    let iconType = 'fa-solid';

    if (alias !== undefined) {
        switch (alias.toUpperCase()) {
            case 'SOLID':
                iconType = 'fa-solid';
                break;
            case 'REGULAR':
                iconType = 'fa-regular';
                break;
            case 'BRAND':
                iconType = 'fa-brands';
                break;
            default:
                break;
        }
    }
    return iconType;
}


/**
 * Gets FontAwesome icon
 * @alias Ptx.html.icon
 * @param o config object - icon - required - FontAwesome icon name, cssClass - can be null - another classes for css, cssStyle - can be null - css style,
 *          faStyle - (solid, regular, brands) can be empty (default "fa-solid") - Font Awesome icon type
 * @returns {string}
 */
export function icon(o) {

    if (o.cssClass === undefined) {
        o.cssClass = '';
    }

    if (o.title === undefined) {
        o.title = '';
    } else {
        o.title = 'title="' + o.title + '"';
    }

    if (o.cssStyle === undefined) {
        o.cssStyle = '';
    } else {
        o.cssStyle = 'style="' + o.cssStyle + '"';
    }

    let iconType = getFaClassFromAlias(o.faStyle);

    return '<i class="' + iconType + ' ' + o.icon + ' ' + o.cssClass + '" ' + o.cssStyle + ' ' + o.title + '></i>';
}

/**
 * @alias Ptx.html.tracePlanButton
 * @param data
 * @param type
 * @param row
 * @return {string}
 */
export function tracePlanButton(data, type, row) {
	let html = '';
	html += '<div class="btn-group">'
			+ '<a href="#" class="btn btn-menu dropdown-toggle btn-with-label" data-bs-toggle="dropdown" aria-expanded="false" style="padding: 1px 6px; min-height: 20px;">'
			+ Ptx.html.icon({icon: "fa-caret-down"})
			+ '		<span class="label label-danger" data-update="notificationCount">' + row.unresolveNotification + '</span>'
			+ '</a>'
			+ '<ul class="dropdown-menu dropdown-menu-right" role="menu">';

	html += '<li></li>';
	let btn = Ptx.html.btn({
		href: getUrl('/tracePlan/dispatcher/notification.htm?id=' + row.id, true),
		className: 'ptx-show-modal',
		moreLinkAttributes: 'data-ptx-modal-size="modal-full"',
		icon: 'fa-mobile fa-fw',
		content: Ptx.getMsg('menu.reseller.system.notification') + ' <span class="label label-danger pull-right" data-update="notificationCount">' + row.unresolveNotification + '</span>'
	});

	html += '<li>' + btn + '</li>';

	if (row.state.id == 1) {//ongoing see TracePlanStateEnum.java
		let btn2 = Ptx.html.btn({
			href: getUrl('/tracePlan/dispatcher/prematurelyEnd.htm?id=' + row.id, true),
			className: 'ptx-call-action',
			icon: 'fa-stop fa-fw',
			content: Ptx.getMsg('tracePlan.prematurelyEnd')
		});
		html += '<li>' + btn2 + '</li>';
	}
	let btn3 = Ptx.html.btn({
		href: getUrl('/tracePlan/dispatcher/toggleNotification.htm?id=' + row.id, true),
		className: 'ptx-call-action',
		icon: row.enableNotification ? 'fa-bell-slash' : 'fa-bell',
        faStyle: 'regular',
		content: row.enableNotification ? Ptx.getMsg('tracePlan.notifications.disable') : Ptx.getMsg('tracePlan.notifications.enable')});
	html += '<li>' + btn3 + '</li>';
	html += '</ul></div>';
	return html;
}

/**
 * Upozorneni a pripade potvrzeni smazani cisel a deaktivace prvku formulare pri nastaveni NO_SIM
 * ICCID pouze pro čtení, pokud je vyplněno MSISDN; při změně MSISDN se smaže ICCID.
 * 
 * Vyuziva se na formularich s jednotnym rozhranim "SimOnUnitForm".
 * 
 * @alias Ptx.html.formWithSim
 * @param ctx
 */
export function formWithSim(ctx) {
	var noSim = $("#noSim", ctx);
	if(noSim.is(":checked")) {
		disableSim();
	}
	noSim.change( function() {			
	if(noSim.is(":checked")) {
		if (confirm(Ptx.getMsg('es.unitNoSim.confirm'))) {
			disableSim();
		}
		else
			noSim.prop('checked', false);
	} else {
		$("#MSISDN", ctx).prop("disabled", false);
		$("#iccid", ctx).prop("disabled", false);
		$("[id^=simOwnerId]", ctx).prop("disabled", false);
	}
	});
	function disableSim() {
		$("#MSISDN", ctx).val("").prop("disabled", true);
		$("#iccid", ctx).val("").prop("disabled", true);
		$("[id^=simOwnerId]", ctx).prop("checked", false).prop("disabled", true);
	}
	
	function disableIccid(init) {
		if($('input[type="hidden"]#noSim').length > 0) {
			return; // Nevykonávat v případě, že je celý blok pro nastavování SIM pouze READONLY z důvodu pevného SIM CHIPu na Unit.
		}
		
		if (msisdn.val() === '' && iccid.prop('readonly')) {
			iccid.prop('readonly', false);
		} else if (msisdn.val() !== '' && !iccid.prop('readonly')) {
			iccid.prop('readonly', true);
		} 
		if (!init && iccid.prop('readonly')) {
			iccid.val("");
		}
	}
	var msisdn = $("#MSISDN", ctx);
	var iccid = $("#iccid", ctx);
	disableIccid(true);
	msisdn.on('input', function() {
		disableIccid(false); 
	});
}
